function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCoin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Logo"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 359",
    x: 0.5,
    y: 0.5,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#F89A29",
    style: {
      fill: "#F89A29",
      fill: "color(display-p3 0.9725 0.6039 0.1608)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M22.5617 14.9257C22.8084 13.2477 21.5352 12.3396 19.7782 11.7375L20.3507 9.45743L18.9688 9.11197L18.4161 11.3328C18.0509 11.244 17.6758 11.1552 17.3007 11.0762L17.8535 8.84547L16.4716 8.5L15.909 10.7702C15.603 10.7011 15.3069 10.632 15.0207 10.5629V10.5531L13.1058 10.0793L12.7406 11.5598C12.7406 11.5598 13.7671 11.7967 13.7474 11.8066C14.31 11.9448 14.4087 12.3199 14.389 12.616L13.7375 15.2119C13.777 15.2218 13.8263 15.2316 13.8856 15.2613C13.8362 15.2514 13.7869 15.2415 13.7375 15.2218L12.8294 18.8541C12.7603 19.0219 12.5827 19.2785 12.1977 19.1798C12.2076 19.1996 11.1909 18.9331 11.1909 18.9331L10.5 20.5222L12.3063 20.9762C12.6419 21.0651 12.9676 21.144 13.2933 21.2329L12.7209 23.5327L14.1027 23.8782L14.6752 21.5981C15.0503 21.6968 15.4254 21.7955 15.7807 21.8843L15.2181 24.1545L16.5999 24.5L17.1724 22.2002C19.5413 22.6444 21.318 22.4667 22.0583 20.3248C22.6604 18.6073 22.0287 17.6104 20.785 16.959C21.703 16.7517 22.384 16.1496 22.5617 14.9257ZM19.3933 19.3674C18.9688 21.0848 16.0669 20.157 15.1292 19.9201L15.8893 16.8701C16.827 17.107 19.8473 17.5709 19.3933 19.3674ZM19.8276 14.8961C19.4328 16.4655 17.0244 15.6659 16.2446 15.4685L16.9355 12.7048C17.7153 12.9022 20.2323 13.2674 19.8276 14.8961Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoin);
export default __webpack_public_path__ + "static/media/coin.8a4272fc26852f1f1a51cb705d9bc0bc.svg";
export { ForwardRef as ReactComponent };